



































































































































































































import {
  ref,
  defineComponent,
  toRefs,
  reactive,
  computed,
} from '@vue/composition-api'

import DialogEditor from '@/components/custom/DialogEditor.vue'
const maxSize = 1024 * 1024 * 1024
const isbnCharachters =
  'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789-_'

  const erweitertesWissen = 'E'
  const grundWissen = 'G'
export default defineComponent({
  name: 'TextbookIssueForm',
  components: {
    DialogEditor,
  },
  props: {
    textbook: Object,
    loading: Boolean,
    textbookIssue: Object,
  },
  setup(props, context) {
    const TextbookForm = ref(null)
    const data = reactive({
      isbn: props.textbookIssue ? props.textbookIssue.isbn : '',
      name: props.textbookIssue ? props.textbookIssue.name : '',
      description: props.textbookIssue ? props.textbookIssue.description : '',
      pageLinkTitle: props.textbookIssue ? props.textbookIssue.pageLinkTitle : '',
      pageLinkSubtitle: props.textbookIssue ? props.textbookIssue.pageLinkSubtitle : '',
      pageNumberStart: props.textbookIssue ? props.textbookIssue.pageNumberStart : 2,
      numberOfPages: props.textbookIssue
        ? props.textbookIssue.numberOfPages
        : '',
      noElementsMessageStudent: props.textbookIssue
        ? props.textbookIssue.noElementsMessageStudent
        : '',
      noElementsMessageTeacher: props.textbookIssue
        ? props.textbookIssue.noElementsMessageTeacher
        : '',
      file: null,
      doublePageMode: props.textbookIssue
        ? props.textbookIssue.doublePageMode
        : false,
      licenseMissingTextStudent: props.textbookIssue
        ? props.textbookIssue.licenseMissingTextStudent
        : '',
      introTextStudent: props.textbookIssue
        ? props.textbookIssue.introTextStudent
        : '',
      introTextTeacher: props.textbookIssue
        ? props.textbookIssue.introTextTeacher
        : '',
      news:
        props.textbookIssue && props.textbookIssue.news
          ? props.textbookIssue.news
          : [],
      isErweitertesWissen: props.textbookIssue ? props.textbookIssue.type === erweitertesWissen : false,
      isGrundwissen: props.textbookIssue ? props.textbookIssue.type === grundWissen : false,

    })

    const dialogEditorOpen = ref(false)
    const dialogEditorContent = ref('')
    const dialogShopLinkEnabled = ref(false)
    const dialogEditorProperty = ref(
      null as
        | 'introTextStudent'
        | 'introTextTeacher'
        | 'licenseMissingTextStudent'
        | 'noElementsMessageStudent'
        | 'noElementsMessageTeacher'
    )

    const startDialogEdit = (
      property:
        | 'introTextStudent'
        | 'introTextTeacher'
        | 'licenseMissingTextStudent'
        | 'noElementsMessageStudent'
        | 'noElementsMessageTeacher'
    ) => {
      if (!Object.prototype.hasOwnProperty.call(data, property)) {
        throw new Error('dialogEditor.start.invalidProperty')
      }
      dialogEditorContent.value = data[property]
      dialogEditorProperty.value = property
      dialogShopLinkEnabled.value = property === 'licenseMissingTextStudent'
      dialogEditorOpen.value = true
    }

    const allowedPageNumbers = new Array(5).fill(null).map((el, i) => ({ value: i + 1, label: `${i + 1}`}))

    const applyDialogEdit = (content: string) => {
      if (
        !Object.prototype.hasOwnProperty.call(data, dialogEditorProperty.value)
      ) {
        throw new Error('dialogEditor.apply.invalidProperty')
      }

      data[dialogEditorProperty.value] = content
      dialogEditorOpen.value = false
      dialogEditorProperty.value = null
      dialogEditorContent.value = ''
    }

    const valid = ref(true)
    const dragover = ref(false)

    const rules = reactive({
      isbnRules: [
        (v: string) => !!v || context.root.$t('textbookIssue.form.error.isbn'),
        (v: string) => {
          for (const char of v) {
            if (!isbnCharachters.includes(char)) {
              return context.root.$t(
                'textbookIssue.form.error.isbnInvalidCharacter',
                { char }
              )
            }
          }
          return true
        },
      ],
      nameRules: [
        (v: string) => !!v || context.root.$t('textbookIssue.form.error.name'),
      ],
      descriptionRules: [
        () => true || context.root.$t('textbookIssue.form.error.description'),
      ],
      pageLinkTitleRules: [
        () => true || context.root.$t('textbookIssue.form.error.pageLinkTitle'),
      ],
      pageLinkSubtitleRules: [
        () => true || context.root.$t('textbookIssue.form.error.pageLinkSubtitle'),
      ],
      numberOfPagesRules: [
        () => true || context.root.$t('textbookIssue.form.error.numberOfPages'),
      ],
      noElementsMessageRules: [
        () =>
          true || context.root.$t('textbookIssue.form.error.noElementsMessage'),
      ],
      introText: [
        () => true || context.root.$t('textbookIssue.form.error.introText'),
      ],
      licenseMissingText: [
        () =>
          true ||
          context.root.$t('textbookIssue.form.error.licenseMissingText'),
      ],
      fileRules: [
        () =>
          !data.file ||
          data.file.type.includes('pdf') ||
          context.root.$t('textbookIssue.form.error.noPdf'),
        () =>
          !data.file ||
          data.file.size < maxSize ||
          context.root.$t('textbookIssue.form.error.fileTooLarge', {
            maxSize: (maxSize / (1024 * 1024 * 1024)).toFixed(2),
          }),
      ],
      typeRules: [
        () => !(data.isErweitertesWissen && data.isGrundwissen) || context.root.$t('textbookIssue.form.error.bothWissenChosen')
      ]
    })

    const onGrundwissenChange = (value: boolean) => {
      if (value && data.isErweitertesWissen) {
        data.isErweitertesWissen = false
      }
    }

    const onErweitertesWissenChange = (value: boolean) => {
      if (value && data.isGrundwissen) {
        data.isGrundwissen = false
      }
    }

    const getInnerTextEllipsis = (html: string, numberOfChars = 40) => {
      const div = document.createElement('div')
      const htmlString = html
        .replace(/<\/p>/g, ' </p>')
        .replace(/<\/h2>/g, ' </h2>')
        .replace(/<\/h1>/g, ' </h1>')
      div.innerHTML = htmlString
      const text = div.innerText
      return text.length > numberOfChars
        ? text.slice(0, numberOfChars) + '...'
        : text
    }

    const submit = async (event: Event) => {
      event.preventDefault()
      event.stopPropagation()
      const form = TextbookForm.value
      if (!form.validate()) {
        setTimeout(() => {
          const firstErrorElement = form.$el.querySelector('.error--text')
          if (firstErrorElement) {
            firstErrorElement.scrollIntoView()
          }
        }, 100)
        return
      }
      const formData = {
        ...data,
        type: type.value,
        textbookId: props.textbook.id,
      }
      context.emit('textbook-issue-form-submitted', formData)
    }

    const isEdit = computed(() => !!props.textbookIssue)

    const type = computed(() => {
      if (!data.isGrundwissen && !data.isErweitertesWissen) {
        return ''
      }
      if (data.isGrundwissen) {
        return grundWissen
      }
      return erweitertesWissen
    })

    const addDropFile = (e: DragEvent) => {
      dragover.value = false
      // to support drag and drop https://github.com/vuetifyjs/vuetify/issues/7836#issuecomment-582841222
      data.file =
        e.dataTransfer.files && e.dataTransfer.files.length
          ? e.dataTransfer.files[0]
          : null
    }

    return {
      valid,
      ...toRefs(data),
      ...toRefs(rules),
      TextbookForm,
      isEdit,
      submit,
      addDropFile,
      dragover,
      dialogEditorOpen,
      dialogEditorContent,
      dialogEditorProperty,
      dialogShopLinkEnabled,
      startDialogEdit,
      applyDialogEdit,
      getInnerTextEllipsis,
      onGrundwissenChange,
      onErweitertesWissenChange,
      allowedPageNumbers
    }
  },
})
